import { combineReducers } from "@reduxjs/toolkit";
 
const chatInitialState = {
  selectedChat: null,
  selectedProjectChat: null,
  recentChats: {
    today: [],
    last7Days: [],
    last30Days: []
  },
  loading: false,
  error: null,
  page:1,
  sessionId:null,
  projectSessionId:null,
  projectQueryMessage:{},
  queryMessage:{},

    modelsList: [],
  modelsLoaded: false,
};

const userInitialState = {
  username: null,
  name: null,
  email: null,
  idToken: null,
};
const voiceInitialState = {
  mode: 'idle',
  transcript: '',
  isMicOn:false,
};

const chatReducer = (state = chatInitialState, action) => {
  switch (action?.type) {
    case "FETCH_CHATS_REQUEST":
      return { ...state, loading: true, error: null };
      
    case "FETCH_CHATS_SUCCESS":
      return {
        ...state,
        loading: false,
        recentChats: {
          today: action.payload.today || [],
          last7Days: action.payload.last7Days || [],
          last30Days: action.payload.last30Days || []
        }
      };
      
    case "FETCH_CHATS_FAILURE":
      return { ...state, loading: false, error: action.payload };
      
    case "SET_SELECTED_CHAT":
      return { ...state, selectedChat: action.payload };
    
    case "SET_SELECTED_PROJECT_CHAT":
      return { ...state, selectedProjectChat: action.payload };
      case "SET_PAGE_CHAT":
        return { ...state, page: action.payload };
      
    case "ADD_NEW_CHAT":
      return {
        ...state,
        recentChats: {
          today: [action.payload, ...state.recentChats.today],
          last7Days: state.recentChats.last7Days,
          last30Days: state.recentChats.last30Days
        },
        selectedChat: action.payload
      };

      case "ADD_QUERY_SESSION_ID":
        return {
          ...state,
          sessionId:action.payload
        }
    
      case "ADD_PROJECT_CHAT_SESSION_ID":
        return {
          ...state,
          projectSessionId:action.payload
        }
      case "ADD_QUERY_MESSAGE":
          return {
            ...state,
            queryMessage:action.payload
          }
      case "ADD_PROJECT_QUERY_MESSAGE":
          return {
            ...state,
            projectQueryMessage:action.payload
          }
      case "CLEAR_SELECTED_PROJECT_CHAT":
          return {
            ...state,
            selectedProjectChat:null
          }
      case "SET_MODELS_LIST":
  return {
    ...state,
    modelsList: action.payload,
    modelsLoaded: true,
  };
    case "CLEAR_SELECTED_CHAT":
      return { ...state, selectedChat: null };


      
    default:
      return state;
  }
};


const userReducer = (state = userInitialState, action) => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        ...action.payload,
      };
    case "CLEAR_USER":
      return userInitialState;
    default:
      return state;
  }
};


const voiceReducer = (state = voiceInitialState, action) => {
  switch (action?.type) {
    case 'SET_MODE':
      return {
        ...state,
        mode: action.payload,
      };

    case 'SET_TRANSCRIPT':
      return {
        ...state,
        transcript: action.payload,
      };

    case "SET_MIC":
      return {
        ...state,
        isMicOn: action.payload,
      }

    case 'RESET_VOICE':
      return {
        ...state,
        mode: 'idle',
        transcript: '',
      };
    

    default:
      return state;
  }
};
const reducers = combineReducers({
  chat: chatReducer,
  user:userReducer,
  voiceMode:voiceReducer
});
 
export default reducers;
